const toDay = (value) => {
    if (!value) return null;
    const d = new Date(value);
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
};

const rangesOverlap = (startA, endA, startB, endB) => {
    const aStart = toDay(startA);
    const aEnd = toDay(endA);
    const bStart = toDay(startB);
    const bEnd = toDay(endB);
    if (!aStart || !aEnd || !bStart || !bEnd) return false;
    return aStart <= bEnd && aEnd >= bStart;
};

export const findConflicts = ({
    discounts = [],
    collectionIds = [],
    startDate,
    endDate,
    excludeDiscountId = null,
    collectionNameById = {},
}) => {
    if (!collectionIds.length || !startDate || !endDate) return [];

    const conflicts = [];
    const seen = new Set();

    for (const collectionId of collectionIds) {
        for (const discount of discounts) {
            if (excludeDiscountId && discount.discount_id === excludeDiscountId) continue;
            if (!discount.collection_ids?.includes(collectionId)) continue;
            if (!rangesOverlap(startDate, endDate, discount.start_date, discount.end_date)) continue;

            const key = `${collectionId}:${discount.discount_id}`;
            if (seen.has(key)) continue;
            seen.add(key);

            const collectionMeta = discount.collections?.find((c) => c.collection_id === collectionId);
            conflicts.push({
                collection_id: collectionId,
                collection_name:
                    collectionMeta?.name ||
                    collectionNameById[collectionId] ||
                    collectionId,
                discount_id: discount.discount_id,
                discount_name: discount.name,
                start_date: discount.start_date,
                end_date: discount.end_date,
            });
        }
    }

    return conflicts;
};

export const estimateProductsAffected = (selectedCollections) => {
    const ids = new Set();
    let total = 0;
    selectedCollections.forEach((c) => {
        if (!ids.has(c.collection_id)) {
            ids.add(c.collection_id);
            total += c.product_count || 0;
        }
    });
    return total;
};
